import L from "leaflet";

export const jagIcon = new L.Icon({
  iconUrl: "../loading.png",
  iconSize: [25, 25], // Size of the icon
  iconAnchor: [17, 35], // Point of the icon which will correspond to marker's location
  popupAnchor: [0, -35] // Point from which the popup should open relative to the iconAnchor
});
